import { useState, useEffect, useContext } from "react";
import { Box, Container, Typography, Grid, Paper, Stack, Tabs, Tab, Button } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Booking from "./booking";
import BookingList from "./bookingList";
import Iconify from "components/Iconify";
import BookingCalendar from "./bookingCalenderView";
import { AuthRouteJson } from "helpers/constant";
import { useNavigate } from "react-router-dom";
import { LoginFormContext } from "context/LoginFormContext";
import { MODULES } from "helpers/constant";
import { CheckIcon } from "lucide-react";

export function SectionHeader({ icon, title, subtitle }) {
  return (
    <Box display="flex" alignItems="center" gap={1.5} mb={3}>
      {icon && (
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: 2,
            flexShrink: 0,
            backgroundColor: "#344767",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 20,
            boxShadow: `0 4px 12px #34476744`,
          }}
        >
          {icon}
        </Box>
      )}

      <Box>
        <Typography fontWeight={700} fontSize={18} color="#344767" lineHeight={1.25}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: "#7b809a" }}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export function AmenityCard({ amenity, selected, onToggle, disabled, values }) {
  const isNonMember = values?.memberType !== "member";
  // const deposit = isNonMember ? amenity?.non_member_deposit : amenity?.member_deposit;
  const price = isNonMember ? amenity?.non_member_price : amenity?.member_price;

  return (
    <Box
      onClick={!disabled ? () => onToggle(amenity?.id) : undefined}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: `${selected ? "2px" : "1.5px"} solid ${selected ? "#A68181" : "#d2d6da"}`,
        borderRadius: "12px",
        cursor: disabled ? "default" : "pointer",
        backgroundColor: selected ? "#FFF5F5" : "#ffffff",
        transition: "all 0.2s ease",
        p: "14px 16px",
        "&:hover": !disabled ? { borderColor: "#A68181", backgroundColor: "#FFF5F5" } : {},
      }}
    >
      {/* Radio + Name Row */}
      <Box display="flex" alignItems="center" gap="10px">
        {/* Radio Circle — mirrors the image style */}
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: "20%",
            border: `2px solid ${selected ? "#A68181" : "#c0c0c0"}`,
            backgroundColor: selected ? "#A68181" : "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transition: "border-color 0.2s",
          }}
        >
          {selected && <CheckIcon color="#fff" sx={{ fontSize: 14, color: "#fff" }} />}
        </Box>

        <Typography fontWeight={600} fontSize={14} color="#344767" lineHeight={1.3}>
          {amenity?.name}
        </Typography>
      </Box>

      {/* Price + Deposit Row */}
      <Box display="flex" justifyContent="end" alignItems="center">
        {/* Deposit Badge */}
        {/* <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            fontSize: 11,
            fontWeight: 500,
            color: "#A68181",
            backgroundColor: selected ? "#F0DADA" : "#F9EAEA",
            border: `1px solid ${selected ? "#C9A0A0" : "#E8CECE"}`,
            borderRadius: "6px",
            px: "8px",
            py: "3px",
          }}
        >
          Deposit: ₹{deposit ?? 0}
        </Box> */}

        {/* Price */}
        <Box textAlign="right">
          {/* <Typography fontSize={11} color="#888" lineHeight={1} mb={0.25}>
            Per session
          </Typography> */}
          <Typography fontWeight={700} fontSize={16} color="#A68181" lineHeight={1}>
            ₹{price ?? 0}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export function AddOnCard({ amenity, selected, onToggle, disabled, values }) {
  const isNonMember = values?.memberType !== "member";
  // const deposit = isNonMember ? amenity?.non_member_deposit : amenity?.member_deposit;
  const price = isNonMember ? amenity?.non_member_price : amenity?.member_price;

  return (
    <Box
      onClick={!disabled ? () => onToggle(amenity?.id) : undefined}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        border: `${selected ? "2px" : "1.5px"} solid ${selected ? "#A68181" : "#d2d6da"}`,
        borderRadius: "12px",
        cursor: disabled ? "default" : "pointer",
        backgroundColor: selected ? "#FFF5F5" : "#ffffff",
        transition: "all 0.2s ease",
        p: "14px 16px",
        "&:hover": !disabled ? { borderColor: "#A68181", backgroundColor: "#FFF5F5" } : {},
      }}
    >
      {/* Radio + Name Row */}
      <Box display="flex" alignItems="center" gap="10px">
        {/* Radio Circle — mirrors the image style */}
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            border: `2px solid ${selected ? "#A68181" : "#c0c0c0"}`,
            backgroundColor: selected ? "#FFF5F5" : "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transition: "border-color 0.2s",
          }}
        >
          {selected && (
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: "#A68181",
              }}
            />
          )}
        </Box>

        <Typography fontWeight={600} fontSize={14} color="#344767" lineHeight={1.3}>
          {amenity?.name}
        </Typography>
      </Box>

      {/* Price + Deposit Row */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {/* Deposit Badge */}
        {/* <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            fontSize: 11,
            fontWeight: 500,
            color: "#A68181",
            backgroundColor: selected ? "#F0DADA" : "#F9EAEA",
            border: `1px solid ${selected ? "#C9A0A0" : "#E8CECE"}`,
            borderRadius: "6px",
            px: "8px",
            py: "3px",
          }}
        >
          Deposit: ₹{deposit ?? 0}
        </Box> */}

        {/* Price */}
        <Box textAlign="right">
          {/* <Typography fontSize={11} color="#888" lineHeight={1} mb={0.25}>
            Per session
          </Typography> */}
          <Typography fontWeight={700} fontSize={16} color="#A68181" lineHeight={1}>
            ₹{price ?? 0}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
export default function AmenityBooking() {
  const { modules, getModuleAccess, access } = useContext(LoginFormContext);
  const [tabValue, setTabValue] = useState("bookingList");
  const navigate = useNavigate();
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handelAddBooking = () => {
    navigate("/amenity/booking/add");
  };

  useEffect(() => {
    getModuleAccess(MODULES.AMENITY);
  }, [modules]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} px={3} sx={{ width: "100%", display: "flex", gap: 2, justifyContent: "end" }}>
        <MDBox sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <MDBox
            sx={{
              display: "flex",
              bgcolor: "grey.100",
              borderRadius: "10px",
              p: "3px",
              gap: "2px",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{ minHeight: "unset" }}
            >
              <Tab
                value="bookingList"
                label="Bookings list"
                sx={{
                  minHeight: "unset",
                  px: 1.75,
                  py: 0.75,
                  fontSize: 13,
                  textTransform: "none",
                  borderRadius: "8px",
                  fontWeight: tabValue === "bookingList" ? 500 : 400,
                  color: tabValue === "bookingList" ? "text.primary" : "text.secondary",
                  bgcolor: tabValue === "bookingList" ? "background.paper" : "transparent",
                  border: tabValue === "bookingList" ? "0.5px solid" : "none",
                  borderColor: "divider",
                  transition: "all 0.15s ease",
                }}
              />
              <Tab
                value="calendarView"
                label="Calendar view"
                sx={{
                  minHeight: "unset",
                  px: 1.75,
                  py: 0.75,
                  fontSize: 13,
                  textTransform: "none",
                  borderRadius: "8px",
                  fontWeight: tabValue === "calendarView" ? 500 : 400,
                  color: tabValue === "calendarView" ? "text.primary" : "text.secondary",
                  bgcolor: tabValue === "calendarView" ? "background.paper" : "transparent",
                  border: tabValue === "calendarView" ? "0.5px solid" : "none",
                  borderColor: "divider",
                  transition: "all 0.15s ease",
                }}
              />
            </Tabs>
          </MDBox>
          {access?.write_access && (
            <Button
              variant="contained"
              onClick={() => handelAddBooking()}
              sx={{
                textTransform: "none",
                fontSize: 13,
                display: "flex",
                alignItems: "center",
                gap: 1,
                fontWeight: 500,
                px: 2.25,
                py: 1,
                borderRadius: "10px",
                boxShadow: "none",
                bgcolor: "#A68181",
                color: "#f3f1f1",
                "&:hover": { bgcolor: "#9A3B3B", boxShadow: "none" },
                "&:disabled": { bgcolor: "#dee2e6", color: "#6c757d" },
              }}
            >
              <Iconify icon="solar:add-square-bold" />
              Add Booking
            </Button>
          )}
        </MDBox>
      </MDBox>
      {tabValue === "bookingList" ? <BookingList /> : <BookingCalendar />}
    </DashboardLayout>
  );
}
